import { Typography } from '@mui/material';

import { CHILD_SCHEDULE_HEADING_SX } from '../styles';
import ChildBackgroundLists from './ChildBackgroundLists';
import { ClientScheduleSection } from './clientScheduleSection';

import type { ChildInfoFieldsProps } from './types';

export default function ChildInfoFields({
  backgrounds,
  schedules,
  notAttendingSchool,
  disabled,
  scheduleDisabled,
  showListErrors,
  showScheduleErrors,
  isSavingSchedule,
  behaviorIssuesField,
  onCreateBackground,
  onDeleteBackground,
  onAddSchedule,
  onDeleteSchedule,
}: ChildInfoFieldsProps) {
  return (
    <>
      <ChildBackgroundLists
        backgrounds={backgrounds}
        behaviorIssuesField={behaviorIssuesField}
        disabled={disabled}
        onAdd={onCreateBackground}
        onDelete={onDeleteBackground}
        showListErrors={showListErrors}
      />
      <Typography variant="h6" sx={CHILD_SCHEDULE_HEADING_SX}>
        Client schedule and availability
      </Typography>
      <ClientScheduleSection
        disabled={scheduleDisabled}
        isSaving={isSavingSchedule}
        notAttendingSchool={notAttendingSchool}
        onAdd={onAddSchedule}
        onDelete={onDeleteSchedule}
        schedules={schedules}
        showScheduleErrors={showScheduleErrors}
      />
    </>
  );
}
